import React, { useState } from 'react';
import { Row, Col } from '@themesberg/react-bootstrap';
import { showOk } from '../components/Alerts';
import { Button, Modal, Form } from '@themesberg/react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import quotationApi from '../services/quotation-service';

const SalesQuotationCancelReason = (props) => {
  const { 
    quotationId,
    cancelEvent,
    refreshList
  } = props;

  const { Header, Dialog, Title, Body, Footer } = Modal;
  const [loading, setLoading] = useState(false);

  const { cancelQuotation } = quotationApi

  const cancelQutationSchema = Yup.object().shape({
    reason: Yup.string().required('Reason is required'),
  });

  const formOptions = {
    resolver: yupResolver(cancelQutationSchema),
    mode: 'all',
  };

  const { register, handleSubmit, getValues, formState, reset } = useForm(formOptions);

  const { errors } = formState;

  const handleCancelQuotation = () => {
    setLoading(true);

    let quotationData = new FormData();

    const reason = getValues('reason');

    quotationData.append('quotationId', quotationId);
    quotationData.append('reason', reason);

    cancelQuotation(quotationData).then(() => {
        showOk('Quotation cancelled!');
        reset();
        cancelEvent();
        refreshList();
    });
  }

  return (
    <Modal as={Dialog} backdropClassName="" centered show={true}>
      <Form onSubmit={handleSubmit(handleCancelQuotation)}>
        <Header>
          <Title className="h6">Provide reason why you cancel this quotation</Title>
          <Button variant="close" aria-label="Close" onClick={() => cancelEvent()} />
        </Header>
        <Body>
            <Row className='align-items-start'>
                <Col sm={12} className="mb-3">
                    <Form.Group id="reason">
                        <Form.Label className="light-font">Reason</Form.Label>
                        <Form.Control as="textarea" placeholder='Please add reason' {...register('reason')} rows="3" />
                        {errors.reason?.message && <small className="invalid-fields">{errors.reason.message}</small>}
                    </Form.Group>
                </Col>
            </Row>
        </Body>
        <Footer>
          <Button type="submit" disabled={loading} variant="secondary">
            Submit
          </Button>
          <Button variant="primary" className="ms-auto" onClick={() => cancelEvent()}>
            Cancel
          </Button>
        </Footer>
      </Form>
    </Modal>
  );
};

export default SalesQuotationCancelReason;
